import { useEffect, useState, useCallback } from "react";
import { getThemeMode, setThemeMode, subscribeTheme } from "./theme";

// Subscribe to theme changes. Components that call this re-render when the
// active palette flips, which cascades to their children. App calls it once
// at the top so the whole tree re-reads T on toggle.
export function useTheme() {
  const [mode, setMode] = useState(getThemeMode());
  useEffect(() => subscribeTheme(setMode), []);
  const toggle = useCallback(() => {
    setThemeMode(getThemeMode() === "dark" ? "light" : "dark");
  }, []);
  return { mode, setMode: setThemeMode, toggle };
}
